import { MEDIA_TYPES } from '../../../constants';
import useAIStudioMedia from '../../../ai-studio/hooks/useAIStudioMedia';
import useActiv8Media from '../../hooks/useActiv8Media';
import {
  getActiv8ContentId,
  isActiv8StoryMedia,
  isStoryMediaDeleted,
  isStoryMediaUploading,
} from '../media/storyMediaItem';
import { STORY_MEDIA_SOURCE } from '../media/storyMediaSources';

function useStoryMediaDisplay(media) {
  const isFavorite = media?.source === STORY_MEDIA_SOURCE.FAVORITE;
  const isDeleted = isStoryMediaDeleted(media);
  const isActiv8 = isActiv8StoryMedia(media);
  const isUploading = isStoryMediaUploading(media);

  const typeFromMedia = media?.type;
  const isVideoType = typeFromMedia === MEDIA_TYPES.VIDEO;
  const hasActiv8DisplayLink = Boolean(media?.link && media?.posterLink);
  const shouldFetchActiv8Video = isActiv8 && isVideoType && !hasActiv8DisplayLink;
  const activ8ContentId = shouldFetchActiv8Video ? getActiv8ContentId(media) : null;

  const {
    mediaUrl: favoriteUrl,
    mediaType: favoriteType,
    isLoading: isFavoriteLoading,
  } = useAIStudioMedia({ id: isFavorite ? media?.sourceId : null });

  const { mediaUrl: activ8VideoUrl, isLoading: isActiv8Loading } = useActiv8Media({
    id: activ8ContentId,
    mediaType: typeFromMedia,
  });

  const type = isFavorite ? favoriteType || typeFromMedia : typeFromMedia;
  const isVideo = type === MEDIA_TYPES.VIDEO;

  let link = null;
  let poster = null;

  if (!isDeleted && !isUploading) {
    if (isFavorite) {
      link = favoriteUrl;
      poster = isVideo ? null : favoriteUrl;
    } else if (media?.source === STORY_MEDIA_SOURCE.UPLOADED) {
      link = media.link ?? null;
      poster = media.posterUrl ?? media.posterLink ?? null;
    } else if (isActiv8) {
      if (isVideo) {
        poster = media.posterLink ?? media.link ?? null;
        link = hasActiv8DisplayLink ? media.link : activ8VideoUrl;
      } else {
        link = media.link ?? null;
      }
    } else {
      link = media?.link ?? null;
    }
  }

  const cardSrc = isVideo ? poster : link;

  return {
    type,
    link,
    poster,
    cardSrc,
    isVideo,
    isLoading: isUploading || (isFavorite && isFavoriteLoading) || (shouldFetchActiv8Video && isActiv8Loading),
    isDeleted,
    isFavorite,
  };
}

export default useStoryMediaDisplay;
